import React from 'react';
import PartnerSectionHeader from '../common/PartnerSectionHeader';
import {TaxProfileSection} from 'src/constants/constants';
import {CreateQueryDrawerTab} from 'src/store/app/app.reducer';
import ActionRequired from 'src/CpaCenterV2/common/ActionRequired/ActionRequired';
import PartnerTaxPaymentsTable from './components/PartnerTaxPaymentsTable';

const PartnerTaxPayments = () => {
  return (
    <div style={{display: 'flex', flex: 1, overflow: 'hidden'}}>
      <div
        style={{
          display: 'flex',
          flex: 0.75,
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
        <PartnerSectionHeader
          sectionName="Tax Payments"
          section={TaxProfileSection.TaxPayments}
        />
        <div
          style={{
            overflowY: 'auto',
          }}>
          {/* Subsections here */}
          <PartnerTaxPaymentsTable />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flex: 0.25,
          flexDirection: 'column',
          overflow: 'hidden',
        }}>
        <ActionRequired
          title="Comments"
          dontAllowAdd
          types={[CreateQueryDrawerTab.TAX_PROFILE]}
          taxProfileSection={TaxProfileSection.TaxPayments}
        />
      </div>
    </div>
  );
};

export default PartnerTaxPayments;
